import type { SVGProps } from 'react';

const SvgMailOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h13.991a3 3 0 0 0 3-2.998l.008-10a3 3 0 0 0-3-3.002zM4 7a1 1 0 0 1 1-1h13.999a1 1 0 0 1 1 1v.147l-.006-.009L12 11.84 4.007 7.138 4 7.15zm0 2.454V17a1 1 0 0 0 1 1h13.991a1 1 0 0 0 1-1l.006-7.544L12 14.16z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgMailOutline;
